import { useMemo } from 'react';
import { ADMIN_NAVIGATION_ITEMS } from '@/constants/admin/adminNavigation';

/**
 * Hook to determine which selectors should be displayed based on current path
 * Matches the logic from admin-web's useDisplaySelectors hook exactly
 */
export const useDisplaySelectors = (currentPath?: string) => {
  const displaySelectors = useMemo(() => {
    if (!currentPath) {
      return [];
    }

    const sanitizedPath = currentPath.split("/")[1];
    
    // Get all sub nav items from all navigation items
    const subNavItems = ADMIN_NAVIGATION_ITEMS.flatMap((item) => item.subNavItems || []);

    // Find the active item based on current path
    const activeItem = subNavItems.find(
      (item) => item.path === `/${sanitizedPath}` || currentPath.endsWith(item.path),
    );

    // Return the display selectors for the active item, or empty array if none found
    if (!activeItem || !activeItem.displaySelectors) {
      return [];
    }
    
    return activeItem.displaySelectors;
  }, [currentPath]);

  return displaySelectors;
};
